export { ButtonCheckboxDirective } from './button-checkbox.directive';
export { ButtonRadioDirective } from './button-radio.directive';
export { ButtonsModule } from './buttons.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/buttons/index.js
// module id = 827
// module chunks = 42